import * as React from "react"
const Steady = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={15}
    fill="none"
    {...props}
  >
    <path
      fill="#BDDEFF"
      fillOpacity={1}
      fillRule="evenodd"
      d="M10.313 15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-.75.75ZM2.813 6a.75.75 0 0 1-.75-.75V.75a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-.75.75Z"
      clipRule="evenodd"
    />
    <path
     fill="#BDDEFF"
      fillOpacity={1}
      d="M2.831 6.938c.333 0 .612 0 .84.015.239.016.463.052.68.142.506.21.907.61 1.117 1.116.09.218.125.442.141.68.016.228.016.507.016.84v.038c0 .333 0 .612-.016.84a2.117 2.117 0 0 1-.141.68c-.21.505-.611.907-1.116 1.116a2.12 2.12 0 0 1-.68.142l-.11.004v1.699a.75.75 0 0 1-1.5 0v-1.7c-.037 0-.074 0-.109-.003a2.12 2.12 0 0 1-.68-.142A2.063 2.063 0 0 1 .157 11.29a2.117 2.117 0 0 1-.141-.68A13.329 13.329 0 0 1 0 9.77V9.73c0-.333 0-.612.016-.84.016-.238.051-.462.141-.68.21-.505.611-.907 1.116-1.116.218-.09.442-.126.68-.142.229-.015.508-.016.841-.016h.037ZM10.313 0a.75.75 0 0 1 .75.75v1.698l.109.005c.237.016.462.052.68.142.505.21.906.61 1.116 1.116.09.218.125.442.141.68.016.228.016.507.016.84v.038c0 .333 0 .612-.016.84a2.12 2.12 0 0 1-.141.68c-.21.505-.611.907-1.116 1.116-.218.09-.443.126-.68.142a13.33 13.33 0 0 1-.84.015h-.038c-.333 0-.612 0-.84-.015a2.117 2.117 0 0 1-.68-.142A2.062 2.062 0 0 1 7.656 6.79a2.117 2.117 0 0 1-.141-.68 13.33 13.33 0 0 1-.016-.84V5.23c0-.333 0-.612.016-.84.016-.238.051-.462.141-.68.21-.505.611-.907 1.116-1.116.218-.09.442-.126.68-.142l.11-.005V.75a.75.75 0 0 1 .75-.75Z"
    />
  </svg>
)
export default Steady